import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

import Home from "./Home/Home";
const App = () => {
  return (
    <Router>
        <Routes>
          <Route exact path="/" element={<Home />}/>
          <Route path="*" element={<Home />}/>
        </Routes>
    </Router>
  );
}

export default App;